import React from 'react';
import { connect } from '@gasbuddy/react';
import LoginForm from './login-form';
import sharedStyle from '../../styles/shared.css';
import styles from './styles.css';
import LoggedOutLayout from '../../components/logged-out-layout';
import FormMessage from '../../components/form-message';

/* eslint-disable react/prefer-stateless-function */
class Login extends React.Component {
  render() {
    const forgotPasswordClasses = `${styles.forgotPassword} ${sharedStyle.pullRight}`;
    return (
      <LoggedOutLayout>
        <div className={sharedStyle.textCenter}>
          <FormMessage
            title="Welcome to GasBuddy Business Pages"
            subTitle="The essential platform for growing your business."
          />
          <LoginForm />
        </div>
        <div className={styles.forgotPasswordContainer}>
          <a href="/forgot-password.html" className={forgotPasswordClasses}>Forgot Password?</a>
        </div>
      </LoggedOutLayout>
    );
  }
}

export default connect()(Login);
